import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import FloatingContact from '../../components/feature/FloatingContact';
import { useEffect } from 'react';

const Projects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20 text-center">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark-gray mb-4 md:mb-6">
            Seçili Projeler
          </h1>
          <p className="font-sans text-sm md:text-base text-mid-gray max-w-xl mx-auto leading-relaxed px-4">
            Mimari kimliği güçlü, zamansız mekânlar yaratma vizyonunun somut yansımaları
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="pb-16 md:pb-20 lg:pb-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="space-y-12 md:space-y-16">
            {/* Featured Project 1 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div className="relative h-72 md:h-80 lg:h-96 overflow-hidden rounded-lg group cursor-pointer">
                <img
                  src="https://public.readdy.ai/ai/img_res/5569f248cbc8dc1d4b5ba93259c83f46.jpg"
                  alt="Modern Villa Projesi"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="px-4 md:px-0">
                <div className="flex items-center gap-2 mb-3 md:mb-4">
                  <i className="ri-home-5-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Konut</span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-3 md:mb-4">
                  Modern Villa Projesi
                </h2>
                <p className="text-mid-gray text-sm md:text-base leading-relaxed mb-4 md:mb-6">
                  Minimalist tasarım anlayışıyla şekillenen bu villa projesi, doğal ışık ve mekân akışını ön planda tutar. Geniş cam yüzeyler, iç ve dış mekân arasında kesintisiz bir geçiş sağlarken, sade formlar zamansız bir estetik yaratır.
                </p>
                <div className="space-y-2 text-xs md:text-sm text-mid-gray">
                  <p><strong className="text-dark-gray">Konum:</strong> İstanbul, Türkiye</p>
                  <p><strong className="text-dark-gray">Alan:</strong> 450 m²</p>
                  <p><strong className="text-dark-gray">Yıl:</strong> 2023</p>
                </div>
              </div>
            </div>

            {/* Featured Project 2 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div className="order-2 md:order-1 px-4 md:px-0">
                <div className="flex items-center gap-2 mb-3 md:mb-4">
                  <i className="ri-building-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Ticari</span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-3 md:mb-4">
                  Kurumsal Ofis Merkezi
                </h2>
                <p className="text-mid-gray text-sm md:text-base leading-relaxed mb-4 md:mb-6">
                  Fonksiyonel ve estetik çözümlerin bir araya geldiği bu ofis tasarımı, modern çalışma kültürünün ihtiyaçlarını karşılarken, kurumsal kimliği güçlü bir şekilde yansıtır. Açık plan düzeni ve doğal malzeme kullanımı, verimli ve ilham verici bir çalışma ortamı yaratır.
                </p>
                <div className="space-y-2 text-xs md:text-sm text-mid-gray">
                  <p><strong className="text-dark-gray">Konum:</strong> Ankara, Türkiye</p>
                  <p><strong className="text-dark-gray">Alan:</strong> 1200 m²</p>
                  <p><strong className="text-dark-gray">Yıl:</strong> 2022</p>
                </div>
              </div>
              <div className="relative h-72 md:h-80 lg:h-96 overflow-hidden rounded-lg group cursor-pointer order-1 md:order-2">
                <img
                  src="https://readdy.ai/api/search-image?query=Contemporary%20commercial%20office%20building%20interior%20with%20open%20space%20design%2C%20natural%20wood%20elements%20and%20concrete%20surfaces%2C%20minimalist%20modern%20furniture%2C%20abundant%20natural%20light%20through%20floor%20to%20ceiling%20windows%2C%20professional%20workspace%2C%20clean%20aesthetic%2C%20neutral%20color%20palette%2C%20architectural%20photography%2C%20sophisticated%20atmosphere&width=1000&height=800&seq=proj-office-001&orientation=landscape"
                  alt="Kurumsal Ofis Merkezi"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </div>

            {/* Featured Project 3 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div className="relative h-72 md:h-80 lg:h-96 overflow-hidden rounded-lg group cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20boutique%20hotel%20lobby%20interior%20with%20sophisticated%20minimalist%20design%2C%20luxurious%20natural%20materials%2C%20marble%20and%20wood%20surfaces%2C%20warm%20ambient%20lighting%2C%20contemporary%20refined%20furniture%2C%20high%20ceiling%20with%20architectural%20details%2C%20premium%20quality%2C%20neutral%20elegant%20tones%2C%20professional%20interior%20photography&width=1000&height=800&seq=proj-hotel-002&orientation=landscape"
                  alt="Butik Otel Konsepti"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="px-4 md:px-0">
                <div className="flex items-center gap-2 mb-3 md:mb-4">
                  <i className="ri-hotel-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Özel</span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-3 md:mb-4">
                  Butik Otel Konsepti
                </h2>
                <p className="text-mid-gray text-sm md:text-base leading-relaxed mb-4 md:mb-6">
                  Lüks ve konfor dengesinde özgün bir mekân deneyimi sunan bu butik otel projesi, her detayda özenli tasarım anlayışını yansıtır. Yerel malzemeler ve çağdaş formların buluşması, misafirlere unutulmaz bir konaklama deneyimi sağlar.
                </p>
                <div className="space-y-2 text-xs md:text-sm text-mid-gray">
                  <p><strong className="text-dark-gray">Konum:</strong> Bodrum, Türkiye</p>
                  <p><strong className="text-dark-gray">Alan:</strong> 800 m²</p>
                  <p><strong className="text-dark-gray">Yıl:</strong> 2023</p>
                </div>
              </div>
            </div>

            {/* Featured Project 4 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div className="order-2 md:order-1 px-4 md:px-0">
                <div className="flex items-center gap-2 mb-3 md:mb-4">
                  <i className="ri-home-4-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Konut</span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-3 md:mb-4">
                  Kentsel Dönüşüm Konutları
                </h2>
                <p className="text-mid-gray text-sm md:text-base leading-relaxed mb-4 md:mb-6">
                  Kentsel doku ile uyumlu, çağdaş yaşam standartlarını karşılayan bu konut projesi, sürdürülebilir tasarım ilkelerini benimser. Enerji verimliliği, yeşil alanlar ve sosyal donatılar, yaşam kalitesini artıran temel unsurlardır.
                </p>
                <div className="space-y-2 text-xs md:text-sm text-mid-gray">
                  <p><strong className="text-dark-gray">Konum:</strong> İzmir, Türkiye</p>
                  <p><strong className="text-dark-gray">Alan:</strong> 3500 m²</p>
                  <p><strong className="text-dark-gray">Yıl:</strong> 2021</p>
                </div>
              </div>
              <div className="relative h-72 md:h-80 lg:h-96 overflow-hidden rounded-lg group cursor-pointer order-1 md:order-2">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20residential%20apartment%20building%20exterior%20with%20contemporary%20architecture%2C%20clean%20geometric%20facade%20design%2C%20balconies%20with%20glass%20railings%2C%20landscaped%20courtyard%2C%20natural%20daylight%2C%20professional%20architectural%20photography%2C%20urban%20context%2C%20neutral%20color%20scheme%2C%20high%20quality%2C%20sophisticated%20design&width=1000&height=800&seq=proj-urban-001&orientation=landscape"
                  alt="Kentsel Dönüşüm Konutları"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Projects Grid */}
      <section className="py-16 md:py-20 bg-light-gray">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white rounded-lg overflow-hidden group cursor-pointer">
              <div className="relative h-56 md:h-60 lg:h-64 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Contemporary%20art%20gallery%20interior%20with%20white%20walls%2C%20minimalist%20design%2C%20natural%20lighting%20from%20skylights%2C%20polished%20concrete%20floor%2C%20clean%20exhibition%20space%2C%20modern%20architecture%2C%20professional%20photography%2C%20elegant%20atmosphere%2C%20neutral%20tones%2C%20high%20quality&width=800&height=600&seq=proj-gallery-001&orientation=landscape"
                  alt="Sanat Galerisi"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2 md:mb-3">
                  <i className="ri-palette-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Kültür</span>
                </div>
                <h3 className="font-sans text-lg md:text-xl text-dark-gray mb-2 font-semibold">
                  Çağdaş Sanat Galerisi
                </h3>
                <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                  Sanat eserlerini ön plana çıkaran minimal iç mekân tasarımı
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden group cursor-pointer">
              <div className="relative h-56 md:h-60 lg:h-64 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20upscale%20restaurant%20interior%20with%20sophisticated%20design%2C%20warm%20ambient%20lighting%2C%20elegant%20dining%20furniture%2C%20natural%20wood%20and%20stone%20materials%2C%20open%20kitchen%20concept%2C%20contemporary%20atmosphere%2C%20professional%20interior%20photography%2C%20refined%20aesthetic%2C%20neutral%20warm%20tones&width=800&height=600&seq=proj-restaurant-001&orientation=landscape"
                  alt="Restoran Tasarımı"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2 md:mb-3">
                  <i className="ri-restaurant-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Ticari</span>
                </div>
                <h3 className="font-sans text-lg md:text-xl text-dark-gray mb-2 font-semibold">
                  Gastronomi Mekânı
                </h3>
                <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                  Sıcak ve davetkar atmosferde modern restoran konsepti
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden group cursor-pointer">
              <div className="relative h-56 md:h-60 lg:h-64 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20modern%20retail%20boutique%20interior%20with%20clean%20white%20design%2C%20elegant%20product%20display%20shelving%2C%20natural%20lighting%2C%20polished%20surfaces%2C%20contemporary%20commercial%20space%2C%20professional%20photography%2C%20sophisticated%20atmosphere%2C%20neutral%20color%20palette%2C%20high%20quality&width=800&height=600&seq=proj-retail-001&orientation=landscape"
                  alt="Perakende Mağaza"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2 md:mb-3">
                  <i className="ri-store-line text-dark-gray text-sm"></i>
                  <span className="text-xs text-mid-gray uppercase tracking-wide">Perakende</span>
                </div>
                <h3 className="font-sans text-lg md:text-xl text-dark-gray mb-2 font-semibold">
                  Butik Mağaza Konsepti
                </h3>
                <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                  Marka kimliğini yansıtan özgün perakende mekânı
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Projects;
